import { render, staticRenderFns } from "./ModalDeleteEvent.vue?vue&type=template&id=850e296a&"
import script from "./ModalDeleteEvent.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports